
import {createSlice} from "@reduxjs/toolkit";

export const usageSlice = createSlice({
    name: 'usageSlc',
    initialState: {value: {id: null, fileId: null,externalId: null, licenseId: null, platformId: null,
            propertyId: null, status: null, useStart: null, useEnd: null, language: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            licenseAmount: null, licenseDisplayAmount: null, availBegin: null,
            availEnd: null, executionDate: null, licensee: null,
            platformInternalId: null, platformExternalId: null, platformCode: null, platformName: null,
            service: null, platformTerritory: null, usageMarket: null, owner: null, stakeholderId: null,
            usageDrawerState: false, usageDrawerMode: null, usageGridRefresh: false
        }},
    reducers:

{
    changeUsage: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeUsage } = usageSlice.actions;

export default  usageSlice.reducer ;
